import { autoinject } from "aurelia-framework";
import { SessionStorage } from '../../utils/session-storage-service';
import { ReportLinkAM } from "./report-api";

@autoinject
export class ReportingStateService {
	private readonly reportListStateKey = "horisontti-report-list-state";
	private readonly reportToExportKey = "horisontti-report-to-export";
	constructor() { }

	setReportListState(state: IReportListState) {
		SessionStorage.pushToStorage(this.reportListStateKey, state);
	}

	getReportListState() {
		return SessionStorage.getFromStorage<IReportListState>(this.reportListStateKey);
	}

	removeReportListState() {
		SessionStorage.removeFromStorage(this.reportListStateKey);
	}
	
	setReportToExport(report: IReportToExport) {
		SessionStorage.pushToStorage(this.reportToExportKey, report);
	}
	
	getReportToExport() {
		return SessionStorage.getFromStorage<IReportToExport>(this.reportToExportKey);
	}
	
	removeReportToExport() {
		SessionStorage.removeFromStorage(this.reportToExportKey);
	}
}

export interface IReportListState {
	openFolders: ReportLinkAM[];
	lastViewedReportId: string;
	scrollPosition: number;
}

export interface IReportToExport {
	name: string;
	id: string;
	isFolder: boolean;
}
